import { createSlice } from "@reduxjs/toolkit";

export const selectedServicesSlice = createSlice({
  name: "selected services",
  initialState: {
    selectedServices: [],
  },
  reducers: {
    setSelectedServices: (state, action) => {
      state.selectedServices = action.payload;
    },
  },
});

export const { setSelectedServices } = selectedServicesSlice.actions;

export default selectedServicesSlice.reducer;
